import React from "react"
import PropTypes from 'prop-types'
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import EventPreview from "../components/eventPreview.js"
import Pager from "../components/pager.js"

const Events = ({ data, pageContext }) => {
  const eventPosts = data.allMarkdownRemark

  return (
    <Layout>
      <SEO title="Events" />
      <div className="container-fluid mt-3">
        <h1 className="text-center">Events</h1>
        {eventPosts.edges.map(({ node }) => (
          <EventPreview
            key={node.id}
            title={node.frontmatter.title}
            slug={node.fields.slug}
            image={node.frontmatter.featuredImage.childImageSharp.fluid}
            excerpt={node.frontmatter.excerpt}
            eventDate={node.frontmatter.eventDate}
            eventTime={node.frontmatter.eventTime}
            eventLocation={node.frontmatter.eventLocation}
          />
          ))}
      </div>
      <Pager pageContext={pageContext} />
    </Layout>
  )
}

Events.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired,
}

export const query = graphql`
    query ($skip: Int!, $limit: Int!) {
        allMarkdownRemark(sort: {fields: frontmatter___eventDate, order: DESC}, skip: $skip, limit: $limit, filter: {fileAbsolutePath: {regex: "\\/events/"}}) {
        edges {
            node {
                id
            frontmatter {
                postedDate(formatString: "Do MMM Y")
                eventDate(formatString: "Do MMM Y")
                eventTime
                eventLocation
                title
                featuredImage {
                childImageSharp {
                    fluid(maxWidth: 750) {
                        ...GatsbyImageSharpFluid
                    }
                }
                }
                excerpt
            }
            fields {
                slug
            }
            }
        }
        }
    }
`
export default Events